import * as React from "react";
import Stepper from "../../components/Stepper"

export default function StepperAuth({ steps, activeStep }) {
    return (
        <Stepper activeStep={activeStep} steps={steps} />
    );
}
